import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex flex-col">
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20warm%20peach%20and%20sand%20abstract%20organic%20gradient%20with%20delicate%20fabric%20texture%20overlay%2C%20gentle%20flowing%20curves%2C%20airy%20light%20tones%2C%20minimalist%20luxury%20fashion%20editorial%20backdrop%2C%20no%20text%20no%20logos%2C%20very%20soft%20pastel%20warmth&width=1800&height=1200&seq=hero-bg-sg-v4&orientation=landscape"
          alt="Sugargoo Spreadsheet background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/50 via-background-50/35 to-background-50/95"></div>
      </div>

      <div className="relative z-10 flex flex-col items-center justify-center flex-1 w-full px-4 md:px-8 pt-24 md:pt-32 pb-16">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-accent-100/80 rounded-full mb-8">
            <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
            <span className="text-xs font-semibold text-accent-800">Updated Daily &mdash; June 2026</span>
          </div>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-foreground-950 font-heading leading-[1.05] mb-4">
            Best Sugargoo<br />Spreadsheet 2026
          </h1>
          <p className="text-lg md:text-2xl text-foreground-700 font-heading font-medium mb-6">
            Updated Finds &amp; Shopping Guides
          </p>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto leading-relaxed mb-10">
            Discover the latest Sugargoo Spreadsheet links, sneaker finds, clothing spreadsheets, and verified shopping resources. Your trusted companion for smarter Sugargoo shopping.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 bg-foreground-900 text-background-50 rounded-full text-sm font-semibold hover:bg-foreground-800 transition-all whitespace-nowrap cursor-pointer"
            >
              Sugargoo Spreadsheet
              <i className="ri-arrow-right-up-line ml-2 text-sm"></i>
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              Buy It Now
              <i className="ri-shopping-bag-line ml-2 text-sm"></i>
            </a>
          </div>

          <Link
            to="/articles/what-is-sugargoo-spreadsheet"
            className="inline-flex items-center gap-2 mt-8 text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer"
          >
            New to Sugargoo? Read our beginner guide
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 pb-8 md:pb-12">
        <div className="max-w-6xl mx-auto">
          <div className="rounded-[28px] overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Diverse%20fashion%20and%20lifestyle%20product%20arrangement%20with%20leather%20sneakers%20denim%20jacket%20gold%20watch%20and%20canvas%20backpack%20on%20warm%20sand%20colored%20surface%2C%20soft%20morning%20light%2C%20editorial%20magazine%20style%20flatlay%2C%20high%20end%20catalog%20composition&width=1600&height=600&seq=hero-showcase-v4&orientation=landscape"
              alt="Curated Sugargoo product showcase"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}